$(function(){
  /*----------------------------------------
  MOBILE MENU
  ----------------------------------------*/
  $('.mobile-menu').click(function(){
      $('nav#primary').toggleClass('show');
      var navHeight = 0;
      if($('nav#primary').hasClass('show')){
          var navHeight = $('nav#primary .container').outerHeight();
      }
      $('nav#primary').height(navHeight);
  });

  /*----------------------------------------
  REQUEST DESKTOP VIEW
  ----------------------------------------*/
  // viewport stuff
  var targetWidth = 1000;
  var deviceWidth = 'device-width';
  var viewport = $('meta[name="viewport"]');

  // check to see if local storage value is set on page load
  localStorage.isResponsive = (localStorage.isResponsive == undefined) ? 'true' : localStorage.isResponsive;

  var showFullSite = function(){    
      viewport.attr('content', 'width=' + targetWidth);  
      
      if(!$('#view-options #view-responsive').length){
          $('#view-options').append('<span id="view-responsive">View Mobile Site<span>');
      }    
      
      localStorage.isResponsive = 'false';
  }

  var showMobileOptimized = function(){
      localStorage.isResponsive = 'true';
      viewport.attr('content', 'width=' + deviceWidth);
      $('#view-responsive').remove();
  }

  // if the user previously chose to view full site, change the viewport
  if(Modernizr.localstorage){
      if(localStorage.isResponsive == 'false'){
          showFullSite();
      }
  }    

  $("#view-full").on("click", function(){
      showFullSite();
  });

  $('#view-options').on("click", "#view-responsive", function(){
      showMobileOptimized();
  });
});

/*----------------------------------------
ENABLE CLICK-THROUGH ON HOME SLIDER
----------------------------------------*/
$(document).ready(function(){
  PointerEventsPolyfill.initialize({});
});

/*----------------------------------------
CUSTOM TOTAL PRICE ON PRODUCT PAGES
----------------------------------------*/
function shappify_options_rendered() {
  var rawProductPrice = $('.product-price').text(),
      productPrice = rawProductPrice.replace('$', '')*1,
      rawOptionsPrice = $('#formatted_option_total').text(),
      optionsPrice = rawOptionsPrice.replace('$', '')*1,
      totalPrice = productPrice + optionsPrice,
      totalPrice = totalPrice.toFixed(2),
      validationCount = 0;
  $('<div class="option_and_product_total">Total: <span class="custom_option_total">$'+totalPrice+'</span></div>').insertAfter('#option_total');
  $('#formatted_option_total').bind('DOMSubtreeModified', function () {
    var newRawOptionsPrice = $(this).text(),
        newOptionsPrice = newRawOptionsPrice.replace('$', '')*1,
        newTotalPrice = productPrice + newOptionsPrice,
        newTotalPrice = newTotalPrice.toFixed(2);
    $('.custom_option_total').text('$'+newTotalPrice);
  });
  $('.shappify_option').bind('DOMSubtreeModified', function (){
    if($('.validation_error').length>0){
      $('#product-options').addClass('options-error');
    }
  });
  $(document).on('click', '.shappify_add_to_cart_btn', function(){
    setTimeout(function(){
      if($('.validation_error').length>0){
        $('html,body').animate({
          scrollTop: $("#product-options").offset().top
        }, 500);
      }
    }, 100);
  });
}